import { useCallback, useEffect, useState } from 'react';
import { IAssistCard } from '../../redux/features/assistRequest/assistRequest.props';
import { isAssistCardActive } from '../../redux/features/assistRequest/assistRequest.slice';
import {
  assistClipStore,
  getAssistClipPlayer,
} from '../../utils/assistRequest/hearAndConfirm/clip';

/**
 * HITL-1786 (HITL 8.0.0): the card's pushed clip (contract D11).
 *
 * The card never waits for it. Until `useAssistPool` holds a clip for this
 * card, `clip` is null and the card says there is no audio yet; then Play
 * shows. Nothing plays on its own: browsers allow audio only after a click,
 * and the agent decides whether to listen. Playback stops when the card ends,
 * and the clip is dropped with the card.
 */
const useAssistClip = (card: IAssistCard) => {
  const { requestId } = card;
  const [clip, setClip] = useState(() => assistClipStore.get(requestId));
  const active = isAssistCardActive(card);

  useEffect(() => {
    setClip(assistClipStore.get(requestId));
    const unsubscribe = assistClipStore.subscribe(() =>
      setClip(assistClipStore.get(requestId))
    );
    return () => {
      unsubscribe();
      getAssistClipPlayer().stop();
      assistClipStore.drop(requestId);
    };
  }, [requestId]);

  useEffect(() => {
    if (!active) getAssistClipPlayer().stop();
  }, [active]);

  const play = useCallback(async () => {
    if (!clip) return false;
    return !!(await getAssistClipPlayer().play(clip.samples, clip.sampleRate));
  }, [clip]);

  return { clip, play };
};

export default useAssistClip;
